import { UserData } from '../../models/userData';

export type UserDataState = {
  userData: UserData;
  error: string | null;
  selectedCountryId: string;
  loading: boolean;
};

export const initialState: UserDataState = {
  userData: {
    id: null,
    name: null,
    email: null,
    expansionUserRole: null,
    countries: [],
    nextFeedbackDate: null,
    permissions: [],
  },
  // selectedCountryId: navigator.language
  //   ? navigator.language.split('-')[0]
  //   : 'en',
  //
  selectedCountryId: 'en',
  loading: false,
  error: null,
};
